import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield } from 'lucide-react';
export function Hero() {
  return <section className="pt-8 pb-6 px-4 sm:px-6 bg-white text-center border-b-4 border-brand-cream" data-id="element-84">
      <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-brand-rose/10 border border-brand-rose/20 text-brand-title font-bold text-xs sm:text-sm mb-4 shadow-sm" data-id="element-85">
        <span data-id="element-86">✨</span>
        <span className="tracking-wide uppercase" data-id="element-87">
          POUR LES PROFESSEURS DE DANSE
        </span>
      </div>

      <h1 className="text-3xl sm:text-4xl md:text-5xl font-heading font-bold text-brand-title leading-tight mb-4" data-id="element-88">
        Le Système Complet de Planification pour Professeurs de Danse
      </h1>

      <p className="text-base sm:text-lg text-brand-text font-medium leading-relaxed mb-6 max-w-2xl mx-auto" data-id="element-89">
        Gagnez des heures de préparation chaque semaine grâce à un système
        professionnel conçu pour planifier vos cours, construire des
        progressions pédagogiques, organiser votre année d'enseignement et
        préparer des séances de danse complètes — sans devoir créer chaque cours
        à partir de zéro.
      </p>

      <div className="mb-6" data-id="element-90">
        <a href="#pricing" className="block cursor-pointer" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/6ttQVA2xKvg2v8M78gnpQ7/ChatGPT-Image-8-jul-2026_-07_50_06-p.m..webp" alt="DANCE PRO - Système Complet 6-en-1" className="w-full h-auto object-contain max-w-[320px] sm:max-w-md mx-auto hover:scale-[1.02] transition-transform duration-300 drop-shadow-2xl" data-id="element-92" />
        </a>
      </div>

      <div className="mb-4" data-id="element-93">
        <CTAButton href="#pricing" data-id="element-94">
          🚀 OUI ! JE VEUX MON SYSTÈME MAINTENANT
        </CTAButton>
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2 sm:gap-4 text-xs sm:text-sm text-brand-text font-bold" data-id="element-95">
        <div className="flex items-center gap-1.5" data-id="element-96">
          <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-97" />
          <span data-id="element-98">4,9/5 — Avis vérifiés de professeurs de danse</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-99">
          <Shield className="w-4 h-4 text-brand-rose" data-id="element-100" />
          <span data-id="element-101">Garantie 7 jours — Zéro risque</span>
        </div>
      </div>
    </section>;
}